import { useCallback, useState, useEffect } from 'react';
import { ISourceTimelineEventType, } from '@24i/player-base';
import { useEventListener } from './common';
const detectPlayingClientAd = (currentAd) => {
    if (!currentAd)
        return false;
    if (currentAd.inStreamAdvertisement)
        return false;
    return true;
};
const shouldDisableForwardSeeking = (currentAd, canSkipAd) => {
    if (!currentAd)
        return false;
    if (!currentAd.inStreamAdvertisement)
        return true;
    if (!canSkipAd)
        return true;
    return false;
};
const shouldDisableBackswardSeeking = (currentAd) => {
    if (!currentAd)
        return false;
    if (!currentAd.inStreamAdvertisement)
        return true;
    return false;
};
const findNextAdvertisement = (playerInstance) => {
    let validSince = 0;
    let validUntil = Infinity;
    let advertisement = null;
    if (playerInstance) {
        const { currentTime, timeline, currentAd } = playerInstance;
        if (!currentAd || currentAd.inStreamAdvertisement === true) {
            for (let index = 0; index < timeline.length; index++) {
                const timelineEvent = timeline[index];
                if (timelineEvent.type === ISourceTimelineEventType.ADVERTISEMENT) {
                    if (timelineEvent.start >= currentTime) {
                        advertisement = timelineEvent;
                        validUntil = timelineEvent.start;
                        break;
                    }
                    else {
                        validSince = timelineEvent.end;
                    }
                }
            }
        }
    }
    return {
        validSince,
        validUntil,
        advertisement,
    };
};
export const useAdsData = (playerInstance) => {
    var _a;
    const [currentAdBreak, setCurrentAdBreak] = useState(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentAdBreak);
    const [currentAd, setCurrentAd] = useState(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentAd);
    const [canSkipAd, setCanSkipAd] = useState((_a = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.canSkipAd) !== null && _a !== void 0 ? _a : false);
    const [nextAdvertisement, setNextAdvertisement] = useState(() => findNextAdvertisement(playerInstance));
    const isAdBreakActive = !!currentAdBreak;
    const [isPlayingClientAd, setIsPlayingClientAd] = useState(() => detectPlayingClientAd(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentAd));
    useEffect(() => {
        const ad = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentAd;
        setIsPlayingClientAd(detectPlayingClientAd(ad));
    }, [playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.currentAd]);
    const isSeekingForwardDisabled = shouldDisableForwardSeeking(currentAd, canSkipAd);
    const isSeekingBackwardDisabled = shouldDisableBackswardSeeking(currentAd);
    const onAdChanged = useCallback(() => {
        setCurrentAdBreak(playerInstance.currentAdBreak);
        setCurrentAd(playerInstance.currentAd);
        setCanSkipAd(playerInstance.canSkipAd);
        setNextAdvertisement(findNextAdvertisement(playerInstance));
        setIsPlayingClientAd(detectPlayingClientAd(playerInstance.currentAd));
    }, [playerInstance]);
    const onTimeUpdate = useCallback(() => {
        const { currentTime } = playerInstance;
        const { validSince, validUntil } = nextAdvertisement;
        if (validSince <= currentTime && currentTime < validUntil)
            return;
        setNextAdvertisement(findNextAdvertisement(playerInstance));
    }, [playerInstance, nextAdvertisement]);
    useEventListener('adbreakstarted', onAdChanged, playerInstance);
    useEventListener('adbreakended', onAdChanged, playerInstance);
    useEventListener('adstarted', onAdChanged, playerInstance);
    useEventListener('adskippable', onAdChanged, playerInstance);
    useEventListener('adbreaksrescheduled', onAdChanged, playerInstance);
    useEventListener('timeupdate', onTimeUpdate, playerInstance);
    return {
        isAdBreakActive,
        isPlayingClientAd,
        isSeekingForwardDisabled,
        isSeekingBackwardDisabled,
        currentAdBreak,
        currentAd,
        canSkipAd,
        nextAdvertisement: nextAdvertisement.advertisement,
    };
};
//# sourceMappingURL=adsHelpers.js.map